/* eslint-disable prefer-rest-params */
import { watch, ref } from 'vue';
import { useI18n } from './useI18n';
export function useAnalytics() {
    const { currentLocale } = useI18n();
    const analyticsLoaded = ref(null);
    const ymId = process.env.VUE_APP_YM_ID;
    const gaId = process.env.VUE_APP_GA_ID;
    const checkIfRussianByLanguage = () => {
        const acceptLang = navigator.language.toLowerCase();
        return acceptLang === 'ru' || acceptLang === 'ru-ru';
    };
    const loadYandexMetrica = () => {
        if (!ymId || analyticsLoaded.value === 'yandex')
            return;
        if (analyticsLoaded.value === 'google') {
            const gaScript = document.querySelector('script[src*="googletagmanager"]');
            if (gaScript)
                gaScript.remove();
            delete window.gtag;
            delete window.dataLayer;
        }
        const oldScript = document.querySelector('script[data-yandex-metrica]');
        if (oldScript)
            oldScript.remove();
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.setAttribute('data-yandex-metrica', 'true');
        script.innerHTML = `
    (function(m,e,t,r,i,k,a){
      m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
      m[i].l=1*new Date();
      for(var j=0;j<document.scripts.length;j++){if(document.scripts[j].src===r){return;}}
      k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)
    })(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");
    
    ym(${ymId}, "init", {
      clickmap: true,
      trackLinks: true,
      accurateTrackBounce: true,
      webvisor: true
    });
  `;
        document.head.appendChild(script);
        analyticsLoaded.value = 'yandex';
        const noscript = document.createElement('noscript');
        noscript.innerHTML = `<div><img src="https://mc.yandex.ru/watch/${ymId}" style="position:absolute; left:-9999px;" alt="" /></div>`;
        document.head.appendChild(noscript);
    };
    const loadGoogleAnalytics = () => {
        if (!gaId || analyticsLoaded.value === 'google')
            return;
        if (analyticsLoaded.value === 'yandex') {
            removeYandexMetrica();
        }
        // Инициализируем dataLayer
        window.dataLayer = window.dataLayer || [];
        // КРИТИЧЕСКИ ВАЖНО: используем arguments, не rest parameters
        // eslint-disable-next-line prefer-rest-params
        window.gtag = function () {
            window.dataLayer.push(arguments);
        };
        // Отправляем начальные команды
        window.gtag('js', new Date());
        window.gtag('config', gaId, {
            send_page_view: true,
            page_title: document.title,
            page_location: window.location.href
        });
        // Загружаем скрипт
        const gtagScript = document.createElement('script');
        gtagScript.async = true;
        gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
        gtagScript.onload = () => {
            // Отправляем тестовое событие для проверки
            window.gtag('event', 'analytics_ready', {
                event_category: 'system',
                event_label: 'initialized'
            });
        };
        gtagScript.onerror = () => {
            console.error('');
        };
        document.head.appendChild(gtagScript);
        analyticsLoaded.value = 'google';
    };
    const removeGoogleAnalytics = () => {
        const gaScript = document.querySelector('script[src*="googletagmanager"]');
        if (gaScript)
            gaScript.remove();
        delete window.gtag;
        delete window.dataLayer;
    };
    const removeYandexMetrica = () => {
        const ymScript = document.querySelector('script[data-yandex-metrica]');
        if (ymScript)
            ymScript.remove();
        const ymNoscript = document.querySelector('noscript');
        if (ymNoscript)
            ymNoscript.remove();
        delete window.ym;
    };
    const initAnalyticsOnAccept = () => {
        const isRussian = checkIfRussianByLanguage();
        if (isRussian) {
            loadYandexMetrica();
        }
        else {
            loadGoogleAnalytics();
        }
    };
    watch(currentLocale, (newLocale) => {
        const hasConsent = localStorage.getItem('cookieConsent') === 'all';
        if (!hasConsent)
            return;
        if (analyticsLoaded.value)
            return;
        if (newLocale === 'ru') {
            loadYandexMetrica();
        }
        else {
            loadGoogleAnalytics();
        }
    });
    return {
        loadYandexMetrica,
        loadGoogleAnalytics,
        initAnalyticsOnAccept,
        checkIfRussianByLanguage
    };
}
